const timeSince = (date) => {
    let seconds = Math.floor((new Date() - date) / 1000);
    let interval = seconds / 31536000;
  
    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  };
  
  const statusColor = (value) => {
    if (value === "Open") {
      return "#6554C1";
    }
    if (value === "InProgress") {
      return "#FFAB00";
    }
    if (value === "Complete") {
      return "#36B37E";
    }
  };
  
  const priorityColor = (value) => {
    if (value === "Low") {
      return "#0065FF";
    }
    if (value === "Medium") {
      return "#FFAB00";
    }
    if (["High", "Critical"].includes(value)) {
      return "#FF5630";
    }
  };
  
  export default {
    timeSince,
    statusColor,
    priorityColor
  };
  


// WEBPACK FOOTER //
// ./src/utils/notificationUtil.js